import { RightsReadWriteUtils, type ProjectModule } from '@bc-library/interface'

export const PROJECT_SETTING_ACCESS_KEYS = [
  'settingsProjectStatusAccess',
  'settingsEngagementCategoryAccess',
  'settingsCommissionCategoryAccess',
  'settingsPricingCategoryAccess',
  'settingsObjectItemCategoryAccess',
] as const

export type ProjectSettingAccessKey = typeof PROJECT_SETTING_ACCESS_KEYS[number]

export const hasAnyProjectSettingsAccess = (project?: ProjectModule) => {
  if (!project)
    return false
  if (project.settingsAccess)
    return true
  if (PROJECT_SETTING_ACCESS_KEYS.some(key => project[key]))
    return true
  return RightsReadWriteUtils.canRead(project.planningResourceAccess)
}

export const hasProjectSettingAccess = (
  project: ProjectModule | undefined,
  key: ProjectSettingAccessKey,
) => {
  if (!project)
    return false
  if (project.settingsAccess)
    return true
  if (!PROJECT_SETTING_ACCESS_KEYS.some(k => project[k]))
    return RightsReadWriteUtils.canRead(project.planningResourceAccess)
  return !!project[key]
}

export const hasExplicitProjectSettingAccess = (
  project: ProjectModule | undefined,
  key: ProjectSettingAccessKey,
) => {
  if (!project)
    return false
  // Its own box only: « Tous les paramètres » (settingsAccess) is converted into the boxes
  return !!project[key]
}
